import React, { ChangeEvent, useCallback, useMemo } from 'react';

interface Props {
    /**
     * This controls how many quantity options will be displayed by the quantity selector by default.
     * If the user gets a value higher than this, the higher value will be temporarily added to the options automatically.
     */
    quantityOptionCount: number,
    item: { qty: number },
    onItemQuantityChange: (CartItem, number) => void,
}

/**
 * This is a special quantity selector that can show values that are higher than its quantityOptionCount.
 */
export function CartItemsEditableQuantitySelector({ quantityOptionCount, item, onItemQuantityChange }: Props) {

    const handleQuantityChange = useCallback((event: ChangeEvent<HTMLSelectElement>) => {
        onItemQuantityChange(item, event.target.value)
    }, [onItemQuantityChange])

    const value = item.qty;

    const baseSelectorOptions = useMemo(() => {
        const qtyOptions = [];
        for (let i = 0; i <= quantityOptionCount; i++) {
            qtyOptions.push(<option value={i} key={i}>{i}</option>);
        } return qtyOptions;
    }, [quantityOptionCount]);

    const quantitySelectorOptions = useMemo(() => {
        const qtyOptions = [...baseSelectorOptions];
        if (value > quantityOptionCount) {
            qtyOptions.push(<option value={value} key={value}>{value}</option>);
        }
        return qtyOptions;
    }, [quantityOptionCount, value]);

    return <select className="qtySelect"
        value={value}
        onChange={handleQuantityChange}>
        {quantitySelectorOptions}
    </select>
}